// extracted by mini-css-extract-plugin
export default {"main":"Products_main__X-PN1"};